// Import model
import { UpdateRoomSelectionRequest } from '../models/UpdateRoomSelectionRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateRoomSelectionRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateRoomSelectionRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateRoomSelectionRequest instance
   */
  static deserialize(json: string): UpdateRoomSelectionRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateRoomSelectionRequest instance
   */
  static fromObject(obj: any): UpdateRoomSelectionRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateRoomSelectionRequest');
    }


    const instance: UpdateRoomSelectionRequest = {
      installationTypeId: obj['installationTypeId'] as string | undefined,
      patternTypeId: obj['patternTypeId'] as string | undefined,
      trimWorkId: obj['trimWorkId'] as string | undefined,
      underlaymentId: obj['underlaymentId'] as string | undefined,
      itemId: obj['itemId'] as string | undefined,
      wasteFactor: obj['wasteFactor'] as number | undefined,
      isActive: obj['isActive'] as boolean | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateRoomSelectionRequest instances
   */
  static deserializeArray(json: string): UpdateRoomSelectionRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateRoomSelectionRequest instance to a JSON string
   */
  static serialize(instance: UpdateRoomSelectionRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateRoomSelectionRequest instance to a plain object
   */
  static toObject(instance: UpdateRoomSelectionRequest): any {
    return {
      'installationTypeId': instance.installationTypeId,
      'patternTypeId': instance.patternTypeId,
      'trimWorkId': instance.trimWorkId,
      'underlaymentId': instance.underlaymentId,
      'itemId': instance.itemId,
      'wasteFactor': instance.wasteFactor,
      'isActive': instance.isActive,
    };
  }

  /**
   * Serializes an array of UpdateRoomSelectionRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateRoomSelectionRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
